export default __webpack_public_path__ + "static/media/Ann_img.90d839e5.jpg";